// extracted by mini-css-extract-plugin
export default {"compareOfferFooter":"styles_compareOfferFooter__Y5SNn","buttonWrapper":"styles_buttonWrapper__ieB3v"};